/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedEditorialArticles_item = {
    readonly storyTellingModule: {
        readonly tabs: ReadonlyArray<{
            readonly supplementaryEditorial: {
                readonly articles: ReadonlyArray<{
                    readonly " $fragmentRefs": FragmentRefs<"EditorialModuleArticles_articles">;
                }> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedEditorialArticles_item";
};
export type PdpSharedEditorialArticles_item$data = PdpSharedEditorialArticles_item;
export type PdpSharedEditorialArticles_item$key = {
    readonly " $data"?: PdpSharedEditorialArticles_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedEditorialArticles_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEditorialArticles_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WordpressArticlesType",
              "kind": "LinkedField",
              "name": "supplementaryEditorial",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WordpressArticleType",
                  "kind": "LinkedField",
                  "name": "articles",
                  "plural": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EditorialModuleArticles_articles"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '45e255e2ebe986ee1c60dc11bfef09e9';
export default node;
